import * as React from "react";
import { IAuthenticatedUser, ILoginCredentials } from "../types";

export interface IAuthContext {
    authenticatedUser?: IAuthenticatedUser;
    hasAuthenticatedSession: boolean;
    isInitialized: boolean;
    login: (credentials: ILoginCredentials) => Promise<IAuthenticatedUser | undefined>;
    logout: () => Promise<void>;
}

export const AuthContext = React.createContext<IAuthContext | undefined>(undefined);

AuthContext.displayName = "AuthContext";
